// extracted by mini-css-extract-plugin
module.exports =  {"material":"TeacherMaterial-XRwK__material"};